import antd from 'ant-design-vue/es/locale-provider/zh_CN';
import dayjsLocale from 'dayjs/locale/zh';
import momentCN from 'moment/dist/locale/zh-cn';
import data from '../json/zh.json';

const components = {
  antLocale: antd,
  momentName: 'zh-cn',
  momentLocale: momentCN,
  dayjsName: 'zh-cn',
  dayjsLocale
};
export default {
  ...components,
  ...data
}; /*  */
